angular.module('app.directives.checkout').directive('checkoutPaymentMethod', () => {
  return {
    restrict: 'E',
    scope: {
      vm: '=',
    },
    controller: function ($scope, $rootScope) {
      $scope.allowMonthlyChecks = $rootScope.account.extra_features.allow_monthly_checks;
    },
    template: `
<div class="row text-center">
  <div class="col-xs-6" style="margin-bottom:10px;">
    <button type="button"
            class="btn btn-lg btn-default btn-block"
            ng-class="vm.method == 'cc' ? 'btn-payment-selected' : 'btn-payment'"
            ng-click="vm.onSelectPaymentMethod('cc')">
      <i class="fa fa-credit-card" aria-hidden="true"></i><br>
      Credit Card
    </button>
  </div>
  <div class="col-xs-6" style="margin-bottom:10px">
    <button type="button"
            class="btn btn-lg btn-default btn-block"
            ng-class="vm.method == 'ach' ? 'btn-payment-selected' : 'btn-payment'"
            ng-click="vm.onSelectPaymentMethod('ach')">
      <i class="fa fa-university" aria-hidden="true"></i><br>
      Bank / ACH
    </button>
  </div>
  <a ng-if="!vm.showAllPaymentOptions" ng-hide="vm.selectedInterval == 'monthly' && !allowMonthlyChecks" href="javascript://"
    class="pull-left"
    ng-click="vm.showAllPaymentOptions = true"
    style="font-size:10pt;padding-left:25px">
    More Payment Options
  </a>
  <div ng-if="vm.showAllPaymentOptions">
    <div class="col-xs-6" style="margin-bottom:10px">
      <button type="button"
              class="btn btn-lg btn-default btn-block"
              ng-class="vm.method == 'po' ? 'btn-payment-selected' : 'btn-payment'"
              ng-click="vm.onSelectPaymentMethod('po')">
        <i class="fa fa-envelope-o" aria-hidden="true"></i><br>
        Purchase Order
      </button>
    </div>
    <div class="col-xs-6" style="margin-bottom:10px">
      <button type="button"
              class="btn btn-lg btn-default btn-block"
              ng-class="vm.method == 'check' ? 'btn-payment-selected' : 'btn-payment'"
              ng-click="vm.onSelectPaymentMethod('check')">
        <i class="fa fa-money" aria-hidden="true"></i><br>
        Check
      </button>
    </div>
  </div>
</div>
<div ng-if="vm.method == 'cc'">
  <h3>Credit Card Details</h3>
  <div ng-if="!vm.cardOnFile">
    <div class="form-control"
      style="height:38px;padding-top:10px;"
      ng-init="vm.stripeCard.mount('#stripe-elements-card')">
      <div id="stripe-elements-card"></div>
    </div>
  </div>
  <div ng-if="vm.cardOnFile" style="margin:0 20px">
    <radio-button-well heading="Use Card On File"
                      is-selected="!vm.addNewCard"
                      on-select="vm.addNewCard = false"
                      always-show-transclude="true">
      <i class="fa fa-credit-card" aria-hidden="true"></i> {{vm.cardOnFile.brand}} **** **** **** {{vm.cardOnFile.last4}}
    </radio-button-well>
    <radio-button-well heading="Add New Card"
                      is-selected="vm.addNewCard == true"
                      on-select="vm.addNewCard = true">
      <div class="form-control"
        style="height:38px;padding-top:10px;margin-bottom:15px;"
        ng-init="vm.stripeCard.mount('#stripe-elements-card')">
        <div id="stripe-elements-card"></div>
      </div>
    </radio-button-well>
  </div>
</div>

<div ng-if="vm.method == 'ach'">
  <h3>Bank Account Details</h3>
  <div style="margin:0 20px">
    <div ng-if="vm.bankOnFile">
      <radio-button-well heading="Use Account On File"
                      is-selected="!vm.addNewBankAccount"
                      on-select="vm.addNewBankAccount = false"
                      always-show-transclude="true">
        <i class="fa fa-university" aria-hidden="true"></i> {{vm.bankOnFile.bank_name}} **** **** **** {{vm.bankOnFile.last4}}
      </radio-button-well>
    </div>
    <radio-button-well heading="Link New Bank (ACH) Account"
                      is-selected="vm.addNewBankAccount == true"
                      on-select="vm.openPlaid()">
      <div ng-if="vm.newBankOnFile">
        <i class="fa fa-university" aria-hidden="true"></i> {{vm.newBankOnFile.bank_name}} **** **** **** {{vm.newBankOnFile.last4}}
      </div>
    </radio-button-well>
  </div>
</div>

<div ng-if="vm.isUpgrade && (vm.method == 'cc' || vm.method == 'ach')">
  <p ng-if="vm.isChangingPaymentSource() && !vm.allowDefaultPaymentSourceOverride()" style="margin:10px 0 0 0">
    This source will become your account's default payment source for all future invoices.
  </p>
  <p ng-if="vm.isChangingPaymentSource() && vm.allowDefaultPaymentSourceOverride()" style="margin:0">
    <label style="margin-top:10px">
      <input name="change_default_payment_source"
              type="checkbox"
              ng-model="vm.changeDefaultPaymentSource"
              ng-init="vm.changeDefaultPaymentSource = true">
      Make this my default payment source for all future invoices.
    </label>
  </p>
</div>

<div class="bg-info text-info" ng-if="vm.method == 'check' || vm.method == 'po' || vm.method == 'ach'"
      style="padding:15px;border-radius:4px;margin-top:20px;">
  <i class="fa fa-info-circle"></i>
  <span ng-if="vm.method == 'ach'">
    Bank \/ ACH payments take up to 7 days to process. 
  </span>
  <span>
    Your purchase will not be finalized and any hardware in your order will not be shipped until payment is received. 
  </span>
  <span ng-if="vm.isTrial">
    This could result in your account becoming <b>inactive</b> once your trial expires.
  </span>
</div>
      `,
  };
});



// WEBPACK FOOTER //
// ./app/directives/checkout/checkout-payment-method.js